// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipInfo_tooltip__R+BpV","tooltiptext":"TooltipInfo_tooltiptext__95xS-"};